<div>
  <div
    class="crossButtonStyle"
    (click)="closeOnClick()"
  >
    <span></span>
    <span></span>
  </div>
</div>
